import React from 'react';
import { rewardsFromDiscountMap } from '../../../utils/productGroups';
import CreateBusinessHeader from '../../business/components/CreateBusinessHeader';
import CreateFooter from '../../business/components/CreateFooter';
import ProductsSearch from '../../product/components/ProductsSearch';
import '../../business/Business.css';
import './PromotionProductsPicker.css';

export function PromotionPickerOpenButton({ title, hint, onClick }) {
  return (
    <button type="button" className="promo-picker-openBtn" onClick={onClick}>
      <div className="promo-picker-openBtnText">
        <span className="promo-picker-openBtnTitle">{title}</span>
        <span className="promo-picker-openBtnHint">{hint}</span>
      </div>
      <span className="promo-picker-openBtnChevron" aria-hidden>
        ›
      </span>
    </button>
  );
}

export default function PromotionProductsPicker({
  title,
  subtitle,
  mode = 'select',
  selectedIds = {},
  onToggle,
  discounts = {},
  onDiscountChange,
  onClose,
}) {
  const selectedCount = mode === 'discount'
    ? rewardsFromDiscountMap(discounts).length
    : Object.values(selectedIds).filter(Boolean).length;

  const skeletonItems = React.useMemo(() => Array.from({ length: 4 }, (_, i) => i), []);

  return (
    <div className="promo-products-picker-root">
      <CreateBusinessHeader
        title={title}
        subtitle={subtitle}
        onBack={onClose}
      />

      <main className="promo-products-picker-content">
        <ProductsSearch
          flatten
          emptyText="Товары не найдены."
          toolbar={({ loading }) => (
            <div className="promo-products-picker-listHeader">
              <div className="shop-create-label promo-products-picker-listTitle">Товары</div>
              <div className="shop-create-help shop-create-helpTight">
                {loading
                  ? 'Загрузка…'
                  : selectedCount > 0
                    ? `Выбрано: ${selectedCount}`
                    : 'Ничего не выбрано'}
              </div>
            </div>
          )}
        >
          {({ products, loading }) => (
            <div className="promo-products-picker-list">
              {loading && products.length === 0
                ? skeletonItems.map((item) => (
                    <div
                      key={item}
                      className="promo-products-picker-item promo-products-picker-item--skeleton"
                    >
                      <div className="shop-create-skeleton promo-products-picker-skeletonImage" />
                      <div className="shop-create-skeleton shop-create-skeleton--text promo-products-picker-skeletonName" />
                      <div className="shop-create-skeleton promo-products-picker-skeletonRight" />
                    </div>
                  ))
                : products.map((product) => {
                    const id = product?.id ?? product?._id;
                    const productName = product?.name ?? `Товар #${id}`;
                    const imageUrl = product?.imageUrl || '';

                    if (mode === 'discount') {
                      const value = discounts[id] ?? discounts[String(id)];
                      const displayValue = value === undefined || value === '' ? '' : String(value);
                      const selected = Number(value) > 0;

                      return (
                        <div
                          key={id}
                          className={`promo-products-picker-item promo-products-picker-item--discount${selected ? ' is-selected' : ''}`}
                        >
                          {imageUrl ? (
                            <img
                              className="promo-products-picker-image"
                              src={imageUrl}
                              alt=""
                              loading="lazy"
                            />
                          ) : (
                            <div className="promo-products-picker-image promo-products-picker-image--placeholder" />
                          )}
                          <div className="promo-products-picker-name">{productName}</div>
                          <div className="promo-products-picker-discountWrap">
                            <input
                              type="number"
                              min={0}
                              max={100}
                              className="promo-products-picker-discount"
                              placeholder="0"
                              value={displayValue}
                              onChange={(e) => onDiscountChange?.(id, e.target.value)}
                              aria-label={`Скидка для ${productName}, %`}
                            />
                            <span className="promo-products-picker-suffix">%</span>
                          </div>
                        </div>
                      );
                    }

                    const selected = !!selectedIds[String(id)];
                    return (
                      <button
                        key={id}
                        type="button"
                        className={`promo-products-picker-item${selected ? ' is-selected' : ''}`}
                        onClick={() => onToggle?.(id)}
                        aria-pressed={selected}
                        aria-label={
                          selected
                            ? `${productName}. Нажмите, чтобы убрать`
                            : `${productName}. Нажмите, чтобы выбрать`
                        }
                      >
                        {imageUrl ? (
                          <img
                            className="promo-products-picker-image"
                            src={imageUrl}
                            alt=""
                            loading="lazy"
                          />
                        ) : (
                          <div className="promo-products-picker-image promo-products-picker-image--placeholder" />
                        )}
                        <div className="promo-products-picker-name">{productName}</div>
                        <div
                          className={`promo-products-picker-check${selected ? ' is-filled' : ''}`}
                          aria-hidden="true"
                        >
                          {selected ? '✓' : ''}
                        </div>
                      </button>
                    );
                  })}
            </div>
          )}
        </ProductsSearch>
      </main>

      <CreateFooter
        disabled={false}
        label="Готово"
        onCreate={onClose}
      />
    </div>
  );
}
